import { render, staticRenderFns } from "./properties-component-link.vue?vue&type=template&id=3af7dde4&scoped=true"
import script from "./properties-component-link.vue?vue&type=script&lang=js"
export * from "./properties-component-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af7dde4",
  null
  
)

export default component.exports